import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getPermissionFunction, getUserPermissions } from './usePermissions.jsx';
import useCurrentUserAccess from './useCurrentUserAccess.js';
import {
  DEFAULT_ROLE_PERMISSIONS_CLIENT,
} from 'shared-permissions';

const useClientPermissions = ({ clientId } = {}) => {

  const masqueradeMode = useSelector((state) => state.ui?.masqueradeMode);
  const { data: clientAccess, isLoading } = useCurrentUserAccess();
  const clientAccessData = clientAccess?.clients || {};

  const { roles: clientRoles, permissionOverrides: clientPermissionOverrides } = clientAccessData[clientId] || {};
  const clientPermissions = getUserPermissions(clientRoles, clientPermissionOverrides, DEFAULT_ROLE_PERMISSIONS_CLIENT);
  const hasClientPermission = useCallback((permission, accessRights) => {
    if (clientId && clientId === masqueradeMode?.client?.id) return true;
    return getPermissionFunction(clientPermissions)(permission, accessRights);
  }, [clientId, masqueradeMode?.client?.id, clientPermissions]);
  return { clients: clientAccessData, clientPermissions, hasClientPermission, isLoading };
};

export default useClientPermissions;
